
const initialState = {
RefreshStats:0
};

const RefreshReducer = (state = initialState, action) => {
  switch (action.type) {
 case "REFRESH_STATS":
      return { ...state, RefreshStats: action.payload };
    default: {
      return state; 
    }
  }};

  export default RefreshReducer;